import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const CHANGE_SEARCH_CAP = defineCapability({
  name: 'CHANGE_SEARCH_CAP' as const,
  args: {
    query: args.optional(args.string()),
    filters: args.optional(args.arrayOf(args.string())),
  },
});
